export { default } from "./GeneraPDF"
